export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14215.ac996532.jpg";